import { get } from "./Client";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import { roles } from "constants";

export function getTodayData(siteId) {
	return get(`solarsmart/site/${siteId}/hourlyData/today`).then(elaborateData)
}

export function getWeekData(siteId) {
	return get(`solarsmart/site/${siteId}/hourlyData/week`).then(elaborateData)
}

export function getMonthData(siteId) {
	return get(`solarsmart/site/${siteId}/hourlyData/month`).then(elaborateData)
}

export function getCustomData(siteId, start, end) {
	return get(`solarsmart/site/${siteId}/hourlyData/custom`, {params:{start,end}}).then(elaborateData)
}

export function getDailyData(siteId, start, end) {
	return get(`solarsmart/site/${siteId}/dailyData`, {params:{start,end}}).then(elaborateDailyData)
}

export function getMonthlyData(siteId, start, end) {
	return get(`solarsmart/site/${siteId}/monthlyData`, {params:{start,end}}).then(elaborateDailyData)
}


function checkNullAndRound(value) {
	return (value == null) ? null : Number(+value.toFixed(2))
}

function elaborateData(data) {
	return [
		...data.device.map(d => ({
			...d,
			// modifico il tipo del dato per differenziare la rappresentazione rispetto alla tabella di agrismart
			type: (d.type === 0) ? 'solar1' : d.type,
			// nota: il sensore di temperatura usato è quello del suolo, ma lo visualizzo come temperatura atmosferica
			externalTemperature: d.soilTemperature,
		})),
		...data.plant.map(d => ({
			receiptDate: d.collectTime,
			inverter_energy: checkNullAndRound(d.inverter_energy),
		}))
	]
}

function elaborateDailyData(data) {
	return [
		...data.device.map(d => ({
			receiptDate: d.dataCollectionDate,
			radiatedEnergy: d.totalRadiation ? Number((+d.totalRadiation / 1000).toFixed(2)) : null,
			externalTemperature: d.mediumSoilTemperature,
		})),
		...data.plant.map(d => ({
			receiptDate: d.collectTime,
			inverter_energy: checkNullAndRound(d.inverter_energy),
			pvgis_energy: checkNullAndRound(d.pvgis_energy),
		}))
	]
}

export function useGetSiteList() {
	let project = useSelector(store => store.session.project);
	let params = project ? {pid:project.id} : null;
	const {status, data, error} = useQuery(['siteList', params], () =>
		get(`solarsmart/site`, {params}),
		{enabled: !!project}
	);
	return {status, sites: data || [], error};
}

export function useGetUnassignedPlantList() {
	let user = useSelector(store => store.users.data);
	const {status, data, error} = useQuery(['plantUnassignedList'], () =>
		get(`solarsmart/plant/unassigned`),
		{enabled: !!roles.isSuperUser(user)}
	);
	return {status, unassignedPlants: data || [], error};
}
